import * as React from 'react';
import { NavigationContainerRef } from '@react-navigation/native';
import { RootStackParamList } from './AppNavigator';

// Create a ref for the navigation container
export const navigationRef = React.createRef<NavigationContainerRef<RootStackParamList>>();

/**
 * navigate
 *
 * A utility function to allow navigation from outside of React components,
 * for example, from within a Redux saga or other service.
 *
 * @param name - The name of the route to navigate to.
 * @param params - The parameters to pass to the route.
 */
export function navigate(name: keyof RootStackParamList, params?: any) {
  // We use the `current` property of the ref to get the navigation object
  // and then call the navigate function. The optional chaining `?.` ensures
  // that the app does not crash if the navigation container is not yet mounted.
  navigationRef.current?.navigate(name, params);
}
